import './contact_form_component.scss'
import { Controller } from 'stimulus'
import { getCsrfParamsAsObject } from '~/common/helpers/csrf'
import { AjaxHelper } from '~/common/extensions/ajax_helpers'

export default class extends Controller {
  static targets = ['form', 'successMessage', 'errorMessage']

  submit(event) {
    event.preventDefault()

    const body = Object.fromEntries(new FormData(this.formTarget))
    if (!body.altcha) return  // Altcha hasn't solved yet; it will call requestSubmit() after solving

    const submitButton = this.formTarget.querySelector('[type="submit"]')
    if (submitButton) submitButton.disabled = true

    fetch(this.formTarget.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, ...getCsrfParamsAsObject() }),
    })
      .then((res) => res.json())
      .then((data) => {
        AjaxHelper.doUpdate(data, this.formTarget)
        this.handleResponse(data)
      })
      .catch(() => this.showError('An error occurred. Please try again.'))
      .finally(() => {
        if (submitButton) submitButton.disabled = false
      })
  }

  handleResponse(response) {
    if (response.failure) {
      this.showError(response.update?.['contact-form__errors'] || 'Submission failed')
    } else if (!response.redirect) {
      this.formTarget.classList.add('hidden')
      this.successMessageTarget.classList.remove('hidden')
    }
  }

  showError(message) {
    this.errorMessageTarget.classList.remove('hidden')
    this.errorMessageTarget.textContent = `Unable to submit form: ${message}`
  }
}
